export function formatLocalDateTime(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  const h = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const s = String(date.getSeconds()).padStart(2, "0");
  return `${y}-${m}-${d}T${h}:${min}:${s}`;
}

export function formatLocalDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function normalizeAnswerValText(
  value: unknown,
  questionType?: string
): string | null {
  if (value == null || value === "") return null;

  if (value instanceof Date) {
    if (questionType === "datetime") return formatLocalDateTime(value);
    if (questionType === "date") return formatLocalDate(value);
    return formatLocalDateTime(value);
  }

  if (typeof value === "string") return value;

  if (typeof (value as { toDate?: () => Date }).toDate === "function") {
    const date = (value as { toDate: () => Date }).toDate();
    if (questionType === "datetime") return formatLocalDateTime(date);
    if (questionType === "date") return formatLocalDate(date);
    return formatLocalDateTime(date);
  }

  if (typeof (value as { toISOString?: () => string }).toISOString === "function") {
    const date = new Date((value as { toISOString: () => string }).toISOString());
    if (questionType === "datetime") return formatLocalDateTime(date);
    if (questionType === "date") return formatLocalDate(date);
    return (value as { toISOString: () => string }).toISOString();
  }

  return String(value);
}
